import React from 'react'
import PropTypes from 'prop-types'
import {Checkbox} from 'antd'

const DigitalPlanDrawingProduct = ({product, onChange}) => {
  const uniqueOptions = [
    ['redraw', 'Jeg laster opp skisse selv'],
  ]

  return uniqueOptions.map(([value, label]) => {
    // Disable other options, as only one option can be enabled at a time
    const disabled = uniqueOptions.some(([key]) => value !== key && !!product[key])
    return (
      <div key={value}>
        <Checkbox
          checked={!!product[value]}
          disabled={disabled}
          onChange={e => onChange({[value]: e.target.checked})}
        >
          {label}
      </Checkbox>
      </div>
    )
  })
}

DigitalPlanDrawingProduct.propTypes = {
  product: PropTypes.object.isRequired,
  onChange: PropTypes.func,
}

export default DigitalPlanDrawingProduct
